import * as yup from 'yup';
import { LoginPageFormData } from './LoginPageFormData';
import { PersonalIdentitySchema } from '../../modules/login/PersonalIdentitySchema';

export const LoginPageFormSchema: yup.SchemaOf<LoginPageFormData> = yup.object({
  identity: PersonalIdentitySchema,
  registrationNumber: yup
    .string()
    .label('Registration number')
    .required()
    .matches(/^[0-9a-zA-Z]+$/, '${path} can contain only letters and numbers')
    .max(15),
});
